


const colors = {
    blanco: "#FFFFFF",
    negro: "#000000",
    rojo: "#E2211C",
    amarillo01: "#F4E500",
    amarillo02: "#EBAA00"

};


export default colors;